// Generated by CoffeeScript 1.11.1
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('sp/ui/questions/question_forms/multiple_choice',['require','../question_form','../../check_radio'],function(require) {
  var CheckRadio, MultipleChoice, QuestionForm;
  QuestionForm = require('../question_form');
  CheckRadio = require("../../check_radio");
  return MultipleChoice = (function(superClass) {
    extend(MultipleChoice, superClass);

    function MultipleChoice() {
      return MultipleChoice.__super__.constructor.apply(this, arguments);
    }

    MultipleChoice.prototype.tagName = "ul";

    MultipleChoice.prototype.initialize = function(options) {
      return MultipleChoice.__super__.initialize.call(this, options);
    };

    MultipleChoice.prototype.render = function() {
      var $select;
      MultipleChoice.__super__.render.call(this);
      if (this.model.get('properties').layout === 'dropdown') {
        $select = this.getSelect();
        _.each(this.model.get('properties').labels, (function(_this) {
          return function(label) {
            return $select.find('select').append(_this.getSelectOption(label));
          };
        })(this));
        this.$el.html($select);
      } else {
        _.each(this.model.get('properties').labels, (function(_this) {
          return function(label, index) {
            return _this.$el.append(_this.getChoice(label, index));
          };
        })(this));
        if (this.model.get('properties').random) {
          this.randomize();
        }
        if (this.model.get('properties').layout) {
          this.setLayout();
        }
      }
      if (this.model.get('properties').other) {
        this.$el.append(this.getWriteInChoice());
      }
      return this.el;
    };

    MultipleChoice.prototype.getWriteInChoice = function() {
      var $input, $li, $other, val;
      $li = this.getChoice(this.model.get('properties').other, 'write-in-option').addClass('write-in');
      $other = $("<input>").attr({
        type: "text",
        name: (this.model.get("_id")) + "[write-in]",
        id: (this.model.get("_id")) + "[write-in]"
      });
      $input = $li.find('input').addClass('write-in-checkbox').click(function() {
        return $other.focus();
      });
      val = {
        label: this.model.get('properties').other,
        value: false
      };
      $other.keyup((function(_this) {
        return function(e) {
          var replace;
          val.value = e.target.value;
          if (val.value.length) {
            $input.prop("checked", "checked");
            $other.val(val.value);
          } else {
            val.value = true;
          }
          replace = _.find(_this.values, {
            label: val.label
          });
          if (replace) {
            replace.value = val.value;
          } else {
            _this.values.push(val);
          }
          return _this.trigger(QuestionForm.UPDATE_EVENT, _this);
        };
      })(this));
      return $li.append($other);
    };

    MultipleChoice.prototype.getChoice = function(label, index) {
      var $input, $li, id, type;
      if (this.model.get('properties').layout === 'dropdown') {
        return this.getSelectOption(label);
      }
      label = _.escape(label);
      id = (this.model.get("_id")) + "[" + index + "]";
      $li = $("<li>").addClass('question-item');
      type = this.model.get('properties').multi ? 'checkbox' : 'radio';
      $input = new CheckRadio(type, label, {
        name: this.model.get("_id") || "temporary",
        id: id,
        value: label
      }).render(false);
      $input.change((function(_this) {
        return function(e) {
          _this.values = [];
          _this.$el.find('input:checked').each(function(index, item) {
            var $item, value, writeInVal;
            $item = $(item);
            value = true;
            if ($item.hasClass('write-in-checkbox')) {
              writeInVal = $item.closest('li').find('input[type=text]').val();
              if (writeInVal.length) {
                value = writeInVal;
              }
            }
            return _this.values.push({
              label: _.unescape($item.attr('value')),
              value: value
            });
          });
          return _this.trigger(QuestionForm.UPDATE_EVENT, _this);
        };
      })(this));
      return $li.prepend($input);
    };

    MultipleChoice.prototype.getSelect = function(label, index) {
      var $li, $select, id;
      id = "" + (this.model.get("_id"));
      $li = $("<li>");
      $select = $("<select>").attr({
        id: id
      }).change((function(_this) {
        return function(e) {
          if (e.target.value && e.target.value.length) {
            _this.values = [
              {
                label: e.target.value,
                value: true
              }
            ];
          } else {
            _this.values = [];
          }
          return _this.trigger(QuestionForm.UPDATE_EVENT, _this);
        };
      })(this));
      $select.append($('<option>').attr({
        value: ""
      }).text("—"));
      return $li.prepend($select);
    };

    MultipleChoice.prototype.getSelectOption = function(label) {
      return $('<option>').attr({
        value: label
      }).text(label);
    };

    MultipleChoice.prototype.setValues = function(vals) {
      if (vals == null) {
        vals = this.values;
      }
      if (_.isArray(vals) && vals.length) {
        if (this.model.get('properties').layout === 'dropdown') {
          return this.$el.find('select').val(vals[0].label);
        } else {
          return vals.forEach((function(_this) {
            return function(val) {
              var $input;
              $input = _this.$el.find(".label").filter(function() {
                return $(this).text() === val.label;
              }).siblings('input').first().prop('checked', val.value).trigger('change');
              if ($input.length && $input[0].id.match(/write-in/) && _.isString(val.value)) {
                return _this.$el.find('li.write-in').find('input[type="text"]').val(val.value).trigger('keyup');
              }
            };
          })(this));
        }
      }
    };

    return MultipleChoice;

  })(QuestionForm);
});

